import { TaskIcon, FormIcon, ProcessIcon } from '../../../../../Global/Icons';
import { RegistersIcon } from '../../../../../Global/Icons';

const ACTION_TYPES = {
  taskTemplate: {
    icon: <TaskIcon />,
    text: 'New task',
  },
  taskTemplateBig: {
    icon: <TaskIcon style={{ height: '80%', width: '80%', alignSelf: 'center', justifySelf: 'center' }} />,
    text: 'New task',
  },
  form: { icon: <FormIcon />, text: 'Fill out a' },
  formBig: {
    icon: <FormIcon style={{ height: '80%', width: '80%' }} />,
    text: 'Fill out a',
  },
  process: { icon: <ProcessIcon />, text: 'Start a' },
  processBig: { icon: <ProcessIcon style={{ height: '80%', width: '80%' }} />, text: 'Start a' },
  register: { icon: <RegistersIcon />, text: 'New row' },
  registerBig: { icon: <RegistersIcon style={{ height: '80%', width: '80%' }} />, text: 'New row' },
};

export default ACTION_TYPES;
